<mat-slide-toggle [(ngModel)]="order.ShipToContactOverride" [disabled]="componentDisabled">
    Override Contact</mat-slide-toggle>

<div *ngIf="order.ShipToContactOverride">
    <div>
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Account Name</mat-label>
            <input matInput [(ngModel)]="order.ShipToContact!.BusinessName" />
            <button *ngIf="order.ShipToContact?.BusinessName" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToContact!.BusinessName=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Attention</mat-label>
            <input matInput [(ngModel)]="order.ShipToContact!.Attention" />
            <button *ngIf="order.ShipToContact?.Attention" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToContact!.Attention=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Phone 1</mat-label>
            <input matInput [(ngModel)]="order.ShipToContact!.Phone1" />
            <button *ngIf="order.ShipToContact?.Phone1" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToContact!.Phone1=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Email</mat-label>
            <input matInput [(ngModel)]="order.ShipToContact!.Email" />
            <button *ngIf="order.ShipToContact?.Email" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToContact!.Email=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<table *ngIf="!order.ShipToContactOverride">
    <tr>
        <td>Account Name:</td>
        <td>
            {{order.ShipToContact?.BusinessName}}
        </td>
    </tr>
    <tr>
        <td>Attention:</td>
        <td>
            {{order.ShipToContact?.Attention}}
        </td>
    </tr>
    <tr>
        <td>Phone 1:</td>
        <td>
            {{order.ShipToContact?.Phone1}}
        </td>
    </tr>
    <tr>
        <td>Email:</td>
        <td>
            {{order.ShipToContact?.Email}}
        </td>
    </tr>
</table>

<mat-slide-toggle [(ngModel)]="order.ShipToAddressOverride" [disabled]="componentDisabled">
    Override Address</mat-slide-toggle>

<div *ngIf="order.ShipToAddressOverride">
    <div>
        <mat-form-field appearance="fill" style="width:34em; max-width: 100%;">
            <mat-label>Address 1</mat-label>
            <input matInput [(ngModel)]="order.ShipToAddress!.AddressLine1" />
            <button *ngIf="order.ShipToAddress?.AddressLine1" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToAddress!.AddressLine1=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="fill" style="width:34em; max-width: 100%;">
            <mat-label>Address 2</mat-label>
            <input matInput [(ngModel)]="order.ShipToAddress!.AddressLine2" />
            <button *ngIf="order.ShipToAddress?.AddressLine2" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToAddress!.AddressLine2=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div>
        <mat-form-field appearance="fill" style="width:5em; margin-right: 0.5em;">
            <mat-label>Country</mat-label>
            <input matInput [(ngModel)]="countryID" [matAutocomplete]="country">
            <mat-autocomplete #country="matAutocomplete" panelWidth="auto">
                <mat-option *ngFor="let country of countries" [value]="country.ID">{{country.toString()}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:12em; margin-right: 0.5em;">
            <mat-label>City</mat-label>
            <input matInput [(ngModel)]="order.ShipToAddress!.City" />
            <button *ngIf="order.ShipToAddress?.City" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToAddress!.City=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:5em; margin-right: 0.5em;">
            <mat-label>State</mat-label>
            <input matInput [(ngModel)]="stateID" [matAutocomplete]="state" />
            <mat-autocomplete #state="matAutocomplete" panelWidth="auto">
                <mat-option *ngFor="let state of states" [value]="state.ID">{{state.toString()}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:10em;">
            <mat-label>Postal Code</mat-label>
            <input matInput [(ngModel)]="order.ShipToAddress!.PostalCode" />
            <button *ngIf="order.ShipToAddress?.PostalCode" tabindex="-1" matSuffix mat-icon-button
                (click)="order.ShipToAddress!.PostalCode=null">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-form-field>
    </div>
</div>

<table *ngIf="!order.ShipToAddressOverride">
    <tr>
        <td style="vertical-align: top;">Address :</td>
        <td *ngIf="!!order.ShipToAddress">
            <div>{{order.ShipToAddress.AddressLine1}}</div>
            <div *ngIf="order.ShipToAddress.AddressLine2">{{order.ShipToAddress.AddressLine2}}</div>
            <div>{{order.ShipToAddress.City}}, {{order.ShipToAddress.State}}
                {{order.ShipToAddress.PostalCode}}</div>
            <div>{{order.ShipToAddress.Country}}</div>
        </td>
    </tr>
</table>